import { useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import localDate, { DayjsFormats } from 'shared/lib/dayjs'
import { SurveysPath } from 'entities/ExportRouters'
import type { ContactsSurveysStore } from '../store/ContactsSurveysStore'
import styles from './styles.module.scss'

type ISurveyFieldProps = {
  label: string
  value: string
}

const SurveyField: FC<ISurveyFieldProps> = ({ label, value }) => (
  <div className={styles.field}>
    <Typography ariaLabel={`${label}Label`} variant='text-input-field-r' className={styles.label}>
      {label}
    </Typography>
    <Typography ariaLabel={`${label}Value`} variant='text-input-field-r'>
      {value}
    </Typography>
  </div>
)

type IContactsSurveysProps = {
  store: ContactsSurveysStore
}

export const ContactsSurveys: FC<IContactsSurveysProps> = observer(({ store }) => {
  useEffect(() => {
    store.load()
  }, [store.contactId])

  if (store.loading) return null

  if (store.hasNoSurveys) {
    return (
      <div className={styles.wrap}>
        <Button
          size='medium'
          iconProps={{ icon: 'add' }}
          text='New survey'
          fullWidth
          onClick={() => uiStore.changeRoute({ path: SurveysPath.create })}
        />
      </div>
    )
  }

  const execution = store.executions[0]

  return (
    <div className={styles.wrap}>
      <Typography
        ariaLabel={'npsSectionTitle'}
        variant='body-md-medium'
        className={styles.subsectionTitle}
      >
        NPS
      </Typography>
      <div className={styles.fields}>
        <SurveyField label='Name' value={execution?.survey_name || '—'} />
        <SurveyField
          label='Send time'
          value={
            execution?.sent_at
              ? localDate(execution.sent_at).format(DayjsFormats.fullWithAtDash)
              : '—'
          }
        />
        <SurveyField
          label='Score'
          value={
            execution?.nps_score !== null && execution?.nps_score !== undefined
              ? String(execution.nps_score)
              : '—'
          }
        />
      </div>
    </div>
  )
})
